import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Edit from '../forms/buttons/Edit';
import Cancel from '../forms/buttons/Cancel';
import Save from '../forms/buttons/Save';

export default class ActionsGroup extends PureComponent {
  exitEditMode = event => {
    event.preventDefault();
    this.props.exitEditMode();
  };

  enterEditMode = event => {
    event.preventDefault();
    this.props.enterEditMode();
  };

  render () {
    const { isEditing, isLoading } = this.props;

    return (
      <div className='actions-group'>
        {isEditing ? (
          <Fragment>
            <Save className={isLoading ? 'disabled' : ''} />
            <Cancel onClick={this.exitEditMode} />
          </Fragment>
        ) : (
          <Edit onClick={this.enterEditMode} />
        )}
      </div>
    );
  }
}

ActionsGroup.propTypes = {
  isLoading: PropTypes.bool,
  isEditing: PropTypes.bool,
  enterEditMode: PropTypes.func,
  exitEditMode: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/common/ui/ItemActions.js